import { boot } from 'quasar/wrappers';
import { AxiosError } from 'axios';
import MyToaster from '../utils/toaster';
import { type IAPIErrorRes, ErroCodes } from '../types/IAPIRes';
import { useLoaderStore } from '@/stores/loader';
import { useAuthStore } from '@/stores/auth';
import { Router  , useRoute } from 'vue-router';

let handleErrorFunc: (error: AxiosError<IAPIErrorRes>) => void;

export const createErrorHandler = (router: Router) => {
  return (error: AxiosError<IAPIErrorRes>) => {
    const Loader = useLoaderStore();
    const authStore = useAuthStore();
    const Route = useRoute();

    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (
            error.response.data.data &&
            typeof error.response.data.data === 'object' &&
            'msgError' in error.response.data.data
          ) {
            MyToaster.warning((error.response.data.data as any).msgError);
          } else if (error.response.data.data) {
            MyToaster.warning(error.response.data.data as string);
          }
          authStore.logout();
          if(error.response.data.error_code == ErroCodes.UNAUTHENTICATED_SUBSCRIPTION) {
            router.push('/login');
          }else {
            if (error.response.config.url !== '/login') router.replace('/');
            if ((error.response.data as any).message === 'Unauthenticated.') {
              MyToaster.warning('يرجى تسجيل الدخول');
            }
          }
          break;
        case 403:
        case 422:
          if (!error.response.data.success) {
            const errObj =
              error.response.data.errors || error.response.data.data;
            if (typeof errObj === 'string') MyToaster.error(errObj);
            else
              Object.entries(errObj).forEach(([, value]) => {
                MyToaster.error(value[0]);
              });
          }
          break;
        case 404:
          if (error.response.data.data) {
            MyToaster.error(error.response.data.data as string);
          } else {
            router.push('/404');
          }
          break;
        case 409:
          if (error.response.data.error_code === ErroCodes.INVERIFIED_PHONE) {
            MyToaster.warning(error.response.data.data as string);
            router.push('/verify-account');
          }
          break;
        case 410:
          if (error.response.data.error_code === ErroCodes.WITHOUT_CODE) {
            MyToaster.warning(error.response.data.data as string);
          }
          break;
        case 429:
          if (error.response.data.error_code === ErroCodes.WITHOUT_CODE) {
            MyToaster.warning(error.response.data.data as string);
            router.push({ name: 'HomePage' });
          } else {
            MyToaster.warning('لقد قمت بعمل العديد من المحاولات انتظر لدقيقة واحدة');
          }
          break;
        case 500:
          console.log('dsd' , Route)
          if(Route  && Route.name  == 'HomePage') {
          }else {
            MyToaster.error('حدث خطأ غير متوقع');
          }
          break;
      }
    } else if (error.request) {
      if(Route.name != 'HomePage') {
        MyToaster.error('حدث خطأ فى السيرفر برجاء المحاولة مرة اخرى');
      }
    } else {
      if (error.message === 'NO_TOKEN') MyToaster.error('يرجى تسجيل الدخول');
      else MyToaster.error('حدث خطأ غير متوقع');
    }
    // setTimeout(() => console.clear());

    Loader.hide();
  };
};

export default boot(({ router }) => {
  handleErrorFunc = createErrorHandler(router);
});

export { handleErrorFunc };
